import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../api/axiosInstance";

const api = {
  list: () => axiosInstance.get("/api/superadmin/case-studies-detail/"),
  remove: (id) => axiosInstance.delete(`/api/superadmin/case-studies-detail/${id}/`),
};

const status = (published) => <span style={{ display: "inline-flex", padding: "3px 9px", borderRadius: 12, fontSize: 12, fontWeight: 600, background: published ? "#dcfce7" : "#f1f5f9", color: published ? "#15803d" : "#64748b" }}>{published ? "Published" : "Draft"}</span>;

export default function CaseStudyManager() {
  const routerNavigate = useNavigate();
  const [records, setRecords] = useState([]);

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const navigate = (path, options) => {
    const match = path.match(/^\/cms\/case-studies\/(\d+)$/);
    const record = match && records.find((item) => String(item.id) === match[1]);
    routerNavigate(record ? `/cms/case-studies/${record.slug}` : path, options);
  };
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const load = async () => { setLoading(true); try { const { data } = await api.list(); setRecords(data?.results ?? data?.data ?? []); } finally { setLoading(false); } };
  useEffect(() => { load(); }, []);
  // const remove = async (record) => { if (!window.confirm(`Delete "${record.title}"?`)) return; await api.remove(record.slug); load(); };

const remove = async () => {
  if (!deleteTarget) return;

  try {
    setDeleting(true);

    await api.remove(deleteTarget.slug);

    setRecords((prev) =>
      prev.filter((item) => item.id !== deleteTarget.id)
    );

    setDeleteTarget(null);
  } catch (error) {
    console.error("Failed to deactivate case study:", error);

    alert(
      error.response?.data?.detail ||
      error.response?.data?.message ||
      "Failed to delete case study. Please try again."
    );
  } finally {
    setDeleting(false);
  }
};

  const visible = records.filter((record) => `${record.title} ${record.industry_name || ""}`.toLowerCase().includes(query.toLowerCase()));
  return <div style={{ padding: 24, minHeight: "100vh", background: "#f8fafc", fontFamily: "Inter, Arial, sans-serif", color: "#1e293b" }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 16, marginBottom: 20, flexWrap: "wrap" }}><div><h1 style={{ margin: 0, fontSize: 22, color: "#0f172a" }}>Case Studies</h1><p style={{ margin: "5px 0 0", fontSize: 13, color: "#64748b" }}>Create and publish customer success stories for the public case studies page.</p></div><button onClick={() => navigate("/cms/case-studies/new")} style={{ border: 0, borderRadius: 8, background: "#2563eb", color: "#fff", padding: "10px 16px", fontWeight: 600, cursor: "pointer" }}>+ Add Case Study</button></div>
    <div style={{ display: "flex", gap: 12, marginBottom: 14, flexWrap: "wrap" }}><div style={{ padding: "10px 16px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13 }}><strong>{records.length}</strong> Total</div><div style={{ padding: "10px 16px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13 }}><strong>{records.filter((r) => r.is_published).length}</strong> Published</div></div>
    <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden" }}><div style={{ padding: 16, borderBottom: "1px solid #e2e8f0" }}><input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search case studies" style={{ width: "min(360px, 100%)", padding: "9px 12px", border: "1px solid #cbd5e1", borderRadius: 7, boxSizing: "border-box" }} /></div><table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}><thead><tr style={{ textAlign: "left", background: "#f8fafc", color: "#64748b" }}><th style={{ padding: 12 }}>Case Study</th><th style={{ padding: 12 }}>Industry</th><th style={{ padding: 12 }}>Status</th><th style={{ padding: 12 }}>Updated</th><th style={{ padding: 12 }}>Actions</th></tr></thead><tbody>{loading ? <tr><td colSpan="5" style={{ padding: 28, textAlign: "center", color: "#64748b" }}>Loading...</td></tr> : visible.length === 0 ? <tr><td colSpan="5" style={{ padding: 28, textAlign: "center", color: "#64748b" }}>No case studies found.</td></tr> : visible.map((record) => <tr key={record.id} style={{ borderTop: "1px solid #f1f5f9" }}><td style={{ padding: 12 }}><div style={{ fontWeight: 600, color: "#0f172a" }}>{record.title}</div><code style={{ fontSize: 11, color: "#64748b" }}>/case-studies/{record.slug}</code></td><td style={{ padding: 12 }}>{record.industry_name}</td><td style={{ padding: 12 }}>{status(record.is_published)}</td><td style={{ padding: 12, color: "#64748b" }}>{record.updated_at ? new Date(record.updated_at).toLocaleDateString() : "-"}</td><td style={{ padding: 12, whiteSpace: "nowrap" }}><button onClick={() => navigate(`/cms/case-studies/${record.id}`)} style={{ border: "1px solid #bfdbfe", borderRadius: 6, background: "#eff6ff", color: "#2563eb", padding: "6px 9px", cursor: "pointer" }}>Edit</button><button 
   onClick={() => setDeleteTarget(record)}
    style={{ marginLeft: 7, border: "1px solid #fecaca", borderRadius: 6, background: "#fff", color: "#dc2626", padding: "6px 9px", cursor: "pointer" }}>Delete</button></td></tr>)}</tbody></table></div>

    {deleteTarget && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(15, 23, 42, 0.55)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      padding: 20,
    }}
    onClick={() => !deleting && setDeleteTarget(null)}
  >
    <div
      style={{
        width: "100%",
        maxWidth: 420,
        background: "#fff",
        borderRadius: 14,
        padding: 24,
        boxShadow: "0 20px 50px rgba(0,0,0,0.2)",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        style={{
          width: 46,
          height: 46,
          borderRadius: "50%",
          background: "#fee2e2",
          color: "#dc2626",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 24,
          marginBottom: 16,
        }}
      >
        !
      </div>

      <h2 style={{ margin: "0 0 10px", fontSize: 19, color: "#0f172a" }}>
        Delete Case Study?
      </h2>

      <p style={{ margin: "0 0 24px", fontSize: 14, color: "#64748b", lineHeight: 1.6 }}>
        Are you sure you want to delete{" "}
        <strong style={{ color: "#334155" }}>
          "{deleteTarget.title}"
        </strong>
        ? This case study will be deactivated.
      </p>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
        <button
          type="button"
          disabled={deleting}
          onClick={() => setDeleteTarget(null)}
          style={{
            padding: "10px 16px",
            border: "1px solid #cbd5e1",
            borderRadius: 8,
            background: "#fff",
            color: "#334155",
            cursor: deleting ? "not-allowed" : "pointer",
          }}
        >
          Cancel
        </button>

        <button
          type="button"
          disabled={deleting}
          onClick={remove}
          style={{
            padding: "10px 16px",
            border: 0,
            borderRadius: 8,
            background: deleting ? "#fca5a5" : "#dc2626",
            color: "#fff",
            fontWeight: 600,
            cursor: deleting ? "not-allowed" : "pointer",
          }}
        >
          {deleting ? "Deleting..." : "Yes, Delete"}
        </button>
      </div>
    </div>
  </div>
)}
  </div>;
}
